// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"_8k1PS","content":"HVYfL","footer":"K-uQ8"};